export enum LoanFileType {
    L1 = 0,
    Termsheet = 1,
    PropertyManagementAgreement = 2,
    Other = 3,
}
